import { render } from "./FAQ.vue?vue&type=template&id=3533e3b4"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/FAQ.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3533e3b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3533e3b4', __exports__)) {
    api.reload('3533e3b4', __exports__)
  }
  
  module.hot.accept("./FAQ.vue?vue&type=template&id=3533e3b4", () => {
    api.rerender('3533e3b4', render)
  })

}


export default __exports__